import React from 'react';

export default function ServiceProviderAgreement() {
  return (
    <div className="min-h-screen w-full bg-white text-gray-800 py-12 px-4">
      <div className="max-w-5xl mx-auto space-y-12">

        <h1 className="text-3xl font-bold text-purple-500 text-center">Service Provider Agreement</h1>

        <p className="text-gray-600">
          This agreement outlines the terms for verified service providers operating inside Million2Trillion (M2T) platform.
        </p>

        <div className="bg-white border border-purple-100 rounded-2xl shadow p-8 space-y-8">

          <div>
            <h2 className="text-2xl font-semibold text-purple-500 mb-2">Eligibility</h2>
            <ul className="list-disc space-y-2 pl-6 text-gray-700">
              <li>Service providers must complete full KYC verification and role-based identity approval.</li>
              <li>Providers must submit proof of qualifications, certifications, or expertise applicable to the services offered.</li>
              <li>All services offered on M2T are subject to internal compliance review and periodic audits.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-purple-500 mb-2">Responsibilities</h2>
            <ul className="list-disc space-y-2 pl-6 text-gray-700">
              <li>Ensure complete transparency, pricing accuracy, and deliver promised service quality to M2T users.</li>
              <li>Comply with financial regulations applicable to your jurisdiction and global customer base.</li>
              <li>Maintain data privacy, secure communications, and client confidentiality at all times.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-purple-500 mb-2">Platform Rights</h2>
            <ul className="list-disc space-y-2 pl-6 text-gray-700">
              <li>M2T reserves the right to suspend or terminate service provider listings due to violation of policies, customer complaints, or compliance failures.</li>
              <li>Providers grant M2T limited usage rights to display profiles, reviews, and service details inside the platform.</li>
            </ul>
          </div>

        </div>

        <p className="text-gray-400 italic">
          Participation as a verified service provider implies full agreement to these terms and M2T global operating guidelines.
        </p>
      </div>
    </div>
  );
}
